import { render, staticRenderFns } from "./richWater.vue?vue&type=template&id=a80ae6c2&scoped=true"
import script from "./richWater.vue?vue&type=script&lang=js"
export * from "./richWater.vue?vue&type=script&lang=js"
import style0 from "./richWater.vue?vue&type=style&index=0&id=a80ae6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ae6c2",
  null
  
)

export default component.exports